"use client";

import { usePathname } from "next/navigation";
import { useEffect, useRef } from "react";

function scrollToTop() {
  if (typeof window === "undefined") return;
  if (window.location.hash) return;

  const el = document.scrollingElement;
  if (el) el.scrollTop = 0;
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
}

export function ScrollToTopOnNavigation() {
  const pathname = usePathname();
  const popNavigationRef = useRef(false);

  useEffect(() => {
    const onPopState = () => {
      popNavigationRef.current = true;
    };
    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, []);

  useEffect(() => {
    if (popNavigationRef.current) {
      popNavigationRef.current = false;
      return;
    }

    const raf1 = window.requestAnimationFrame(() => {
      const raf2 = window.requestAnimationFrame(() => {
        scrollToTop();
      });
      return () => window.cancelAnimationFrame(raf2);
    });

    return () => window.cancelAnimationFrame(raf1);
  }, [pathname]);

  return null;
}

